import './IconCell.scss'

interface IconCellProps {
  icon: string
  color?: string
  tooltip?: string
  disabled?: boolean
  size?: number
  onClick?: () => void
  extraIcon?: [string, string]
}

export function IconCell(props: IconCellProps) {
  const hoverClass = props.color ? '' : 'grid-icon-cell-hover'
  return (
    <div className="grid-icon-cell">
      <i
        style={{ cursor: props.onClick ? 'pointer' : 'default', color: props.color, fontSize: props.size }}
        className={`${props.icon} ${hoverClass} ${props.disabled ? 'disabled' : ''}`}
        onClick={props.onClick}
      >
        {!!props.extraIcon && (
          <i
            style={{ cursor: props.onClick ? 'pointer' : 'default', color: props.extraIcon[1] }}
            className={`icon ${props.extraIcon[0]}`}
            onClick={props.onClick}
          ></i>
        )}
        {!!props.tooltip && <span className="grid-icon-cell-tooltip">{props.tooltip}</span>}
      </i>
    </div>
  )
}
